<template>
    <div id="app">
        <router-view></router-view>
        <LayoutMask />
        <transition name="fade">
            <CookiesPopup
                v-if="cookiesPopupOpen"
            />
        </transition>
    </div>
</template>

<script>
import CookiesPopup from "@/components/cookies/CookiesPopup";
import LayoutMask from "@/components/layout/LayoutMask";
import { mapGetters, mapMutations } from 'vuex'

export default {
    components: {
        CookiesPopup,
        LayoutMask,
    },
    data() {
        return {
            cookiesPopupOpen: false
        }
    },
    computed: {
        ...mapGetters({
            cookiesTypes: 'getCookiesTypes'
        }),
        cookiesAdvertisingAllowed() {
            return this.cookiesTypes && this.cookiesTypes.advertising
        }
    },
    created() {
        if (process.env.VUE_APP_BUILD_ENV !== 'production') {
            console.log(process.env.VUE_APP_BUILD_ENV + ' mode')
        }
    },
    mounted() {
        if (window.localStorage.getItem('cookiesTypes')) {
            this.setCookiesTypes(
                JSON.parse(window.localStorage.getItem('cookiesTypes'))
            )
            this.resolveCookiesTypes()
        }
        this.$nextTick(() => {
            setTimeout(() => {
                if (!this.cookiesTypes) {
                    this.cookiesPopupOpen = true
                    this.setMask(true)
                    document.body.classList.add('overflow-hidden')
                }
            }, 700)
        })
    },
    methods: {
        ...mapMutations([
            'setCookiesTypes',
            'setMask'
        ]),
        initGTM(id) {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', id);
        },
        resolveCookiesTypes() {
            if (this.cookiesAdvertisingAllowed) {
                this.initGTM('GTM-PHLMD75')
                this.initGTM('GTM-TVRLF44')
                this.initGTM('GTM-WV3QJWR')
            }
        }
    },
    watch: {
        cookiesTypes(v) {
            if (v) {
                this.cookiesPopupOpen = false
                this.setMask(false)
                document.body.classList.remove('overflow-hidden')
                this.resolveCookiesTypes()
            }
        }
    }
}
</script>

<style lang="scss">
@import 'src/assets/scss/style';
</style>
